import { render, staticRenderFns } from "./SubtitleFormatting.vue?vue&type=template&id=52b9845c&scoped=true&"
import script from "./SubtitleFormatting.vue?vue&type=script&lang=js&"
export * from "./SubtitleFormatting.vue?vue&type=script&lang=js&"
import style0 from "./SubtitleFormatting.vue?vue&type=style&index=0&id=52b9845c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9845c",
  null
  
)

export default component.exports